<template >
    <div class="publicMain">
        <div class="mianbao">
            <!--  -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>养老服务机构</el-breadcrumb-item>
                <el-breadcrumb-item>社区养老</el-breadcrumb-item>
                <el-breadcrumb-item>基本信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 模糊查询 -->
        <div class="childrenFileSelect">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="机构名称">
                    <el-input v-model="form.mechanismName"></el-input>
                </el-form-item>
                <el-form-item label="负责人">
                    <el-input v-model="form.personCharge"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="form.contact"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onCheck">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="onReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="add">
            <el-button type="primary" size="small" @click="add">新增</el-button>
        </div>
        <!-- 表格 -->
        <div class="table">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>

                <el-table-column
                        v-for="(item,index) in tableColumn"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        align="center"
                        header-align="center"
                >
                    <template slot-scope="scope">
                        <div v-if="item.type=='button'">
                            <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" effect="light" content="审批" placement="top-start">
                              <button class="iconfont icon-tongguos tabBtn" @click="audit(scope.row)"></button>
                            </el-tooltip>-->
                        </div>
                        <div v-else-if="item.type=='state'">
                            <div style="text-align:center;">
                                <el-tag v-if="scope.row.state==1">待审核</el-tag>
                                <el-tag v-if="scope.row.state==2" type="success">通过</el-tag>
                                <el-tag v-if="scope.row.state==3" type="danger">不通过</el-tag>
                            </div>
                        </div>
                        <div v-else-if="item.type=='sex'">
                            <div style="text-align:center;">
                                <span v-if="scope.row.sex==0" type="success">男</span>
                                <span v-if="scope.row.sex==1" type="primary">女</span>
                            </div>
                        </div>
                        <div v-else-if="item.type=='nature'">
                            <div style="text-align:center;">
                                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>
                                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>
                                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>
                            </div>
                        </div>
                        <div
                                v-else
                                :style="{'text-align':item.align?item.align:'center'}"
                        >{{scope.row[item.prop]}}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
            ></el-pagination>
        </div>
        <el-dialog :title="title" :visible.sync="visible" width="50%">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="机构名称" prop="mechanismName">
                            <el-input v-model="ruleForm.mechanismName"></el-input>
                        </el-form-item>
                        <el-form-item label="机构类型" prop="mechanismType">
                            <el-select v-model="ruleForm.mechanismType" style="width:100%" disabled>
                                <el-option label="社区养老" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="负责人" prop="personCharge">
                            <el-input v-model="ruleForm.personCharge"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="contact">
                            <el-input v-model="ruleForm.contact"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="地址">
                    <el-input v-model="ruleForm.address" @blur="transLocation" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label>
                    <div id="container" style="width:550px;height:400px;"></div>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input type="textarea" v-model="ruleForm.remarks"></el-input>
                </el-form-item>
                <el-form-item label="上传附件">
                    <upload
                            :fileLists="fileList"
                            :type="typeImg"
                            @success="successImg"
                            @deleteImg="deleteImg"
                    />
                </el-form-item>
            </el-form>
            <div class="button" v-if="title=='新增'">
                <el-button type="primary" @click="save">确定</el-button>
                <el-button type="info" @click="cancel">取消</el-button>
            </div>
            <div class="button" v-if="title=='编辑'">
                <el-button type="primary" @click="save">编辑</el-button>
                <el-button type="info" @click="cancel">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        communityInfoList,
        communityInfoDelete,
        communityInfoEdit,
        communityInfoCheck
    } from "./api";
    import upload from "@/component/componentsP/upImg.vue";

    export default {
        data() {
            return {
                title: "查看", //el-dialog标题
                visible: false, //el-dialog现在
                activeName: "first", //el-tabs切换的
                currentPage: 1, //默认展示第一页
                //模糊查询数据
                form: {

                },
                //table表格的column
                tableColumn: [
                    {
                        prop: "mechanismName",
                        label: "机构名称",
                    },
                    {
                        prop: "address",
                        label: "社区详细地址",
                    },
                    {
                        prop: "personCharge",
                        label: "负责人",
                    },
                    {
                        prop: "contact",
                        label: "联系电话",
                    },

                    {
                        label: "操作",
                        type: "button",
                    },
                ],
                //table表格的数据
                tableData: [],
                pageNo: 1,
                pageSize: 10,
                total: 0, //每页总书记
                buttonType: "", //代表不同button的按钮类别
                row: {}, //按钮当前选中行的数据
                helpTypeManageShow: false, //
                helpAddShow: false, //
                fileList: [],
                typeImg: "",
                helpAuditShow: false, //审核的现实隐藏
                queryData: {}, //
                ruleForm: {
                    mechanismType:2
                },
                rules: {
                    mechanismName: [
                        {required: true, message: "请输入机构名称", trigger: "blur"},
                    ],
                    personCharge: [
                        {required: true, message: "请输入负责人", trigger: "blur"},
                    ],
                    mechanismType: [
                        {required: true, message: "请选择机构类型", trigger: "blur"},
                    ],
                },
            };
        },
        components: {
            upload,
        },
        methods: {
            //模糊查询
            onCheck() {
                this.communityInfoAPI({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    ...this.form,
                });
            },
            //模糊查询的重置
            onReset() {
                this.form = {};
                this.pageNo = 1;
                this.pageSize = 10;
                this.communityInfoAPI();
            },
            //分页选择每页的数据
            handleSizeChange(val) {
                this.pageSize = val;
                this.communityInfoAPI();
                this.$message({
                    message: `每页请求${val}条数据成功`,
                    type: "success",
                });
            },
            //分页选择不同页的数据
            handleCurrentChange(val) {
                this.pageNo = val;
                this.communityInfoAPI();
                this.$message({
                    message: `请求第${val}页数据成功`,
                    type: "success",
                });
            },
            //拿到列表
            communityInfoAPI(e) {
                let params = Object.assign({}, e, {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                });
                communityInfoList(params).then((res) => {
                    this.tableData = res.content.list;
                    this.total = res.content.count;
                });
            },
            //查看
            check(e) {
                this.$router.push({
                    path: "/provideCommunityInfo",
                    query: {
                        row: JSON.stringify(e),
                        buttonType: "check",
                        id: e.id
                    },
                });
            },
            //新增
            add() {
                this.visible = true;
                this.title = "新增";
                this.ruleForm = {
                    mechanismType:2
                };
                this.fileList = [];
                try {
                    this.$refs.ruleForm.clearValidate()
                } catch (error) {

                }
                this.$nextTick(() => {
                    // this.viewMapTemp = true
                    this.mapInit("container");
                });
            },
            //编辑
            compile(e) {
                this.$router.push({
                    path: "/provideCommunityInfo",
                    query: {
                        row: JSON.stringify(e),
                        buttonType: "compile",
                        id: e.id
                    },
                });
            },
            //取消按钮
            cancel() {
                this.visible = false
            },
            //删除
            remove(e) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error",
                })
                    .then(() => {
                        communityInfoDelete({id: e.id}).then((res) => {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.communityInfoAPI();
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },
            successImg(e) {
                this.fileList = e;
            },

            deleteImg(e) {
                this.fileList = e;
            },

            //保存
            save() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        let photo = "";
                        if (this.fileList && this.fileList.length > 0) {
                            this.fileList.forEach((item) => {
                                photo += item.path + ";";
                            });
                        }
                        this.ruleForm = Object.assign({}, this.ruleForm, {
                            photo,
                        });
                        communityInfoEdit(this.ruleForm).then((res) => {
                            this.$message({
                                type: "success",
                                message: this.ruleForm.id ? "编辑成功" : "新增成功",
                            });
                            this.visible = false
                            this.communityInfoAPI();
                        });
                    }
                });
            },
            //根据输入地址转换经纬度并标记
            transLocation() {
                var searchKey = this.ruleForm.address;
                var map = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 18,
                });
                var that = this;
                AMap.plugin("AMap.Geocoder", function () {
                    var geocoder = new AMap.Geocoder({
                        radius: 1000,
                        extensions: "all",
                    });
                    var marker = new AMap.Marker();
                    geocoder.getLocation(searchKey, function (status, result) {
                        if (status === "complete" && result.geocodes.length) {
                            var lnglat = result.geocodes[0].location;
                            that.ruleForm.longitude = lnglat.lng;
                            that.ruleForm.latitude = lnglat.lat;
                            marker.setPosition(lnglat);
                            map.add(marker);
                            map.setFitView(marker);
                        } else {
                            that.$message({
                                message: "获取坐标失败，请手动获取",
                                type: "error",
                            });
                        }
                    });
                });
                var geocoder = new AMap.Geocoder({
                    city: "010", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                });
                map.on("click", function (e) {
                    console.log("e", e);
                    that.ruleForm.longitude = e.lnglat.getLng();
                    that.ruleForm.latitude = e.lnglat.getLat();
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            if (status === "complete" && result.regeocode) {
                                console.log("result", result);
                                var address = result.regeocode.formattedAddress;
                                // that.form.address = address;
                                that.$set(that.ruleForm, "address", address);
                            } else {
                                log.error("根据经纬度查询地址失败");
                            }
                        }
                    );
                });
            },
            //初始化地图插件的方法
            mapInit(containerId) {
                var map = new AMap.Map(containerId, {
                    resizeEnable: true,
                    zoom: 16,
                    center: [118.018197,32.78193], //中心点
                });
                if (this.ruleForm.longitude != undefined && this.ruleForm.latitude != undefined) {
                    var marker = new AMap.Marker({
                        position: [this.ruleForm.longitude, this.ruleForm.latitude],
                        map: map,
                    });
                    map.setFitView(marker);
                } else {
                    AMap.plugin("AMap.Geolocation", function () {
                        //异步定位当前
                        var geolocation = new AMap.Geolocation();
                        map.addControl(geolocation);
                    });
                }
                //定义地图坐标点击事件
                var that = this;
                var geocoder = new AMap.Geocoder({
                    city: "010", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                });
                map.on("click", function (e) {
                    that.ruleForm.longitude = e.lnglat.getLng();
                    that.ruleForm.latitude = e.lnglat.getLat();
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress;
                                // that.form.address = address;
                                that.$set(that.ruleForm, "address", address);
                            } else {
                                log.error("根据经纬度查询地址失败");
                            }
                        }
                    );
                });
            },
        },
        created() {
            this.communityInfoAPI();
        },
    };
</script>

<style lang="less" scoped>
    .publicMain {
        background-color: #fff;
        padding: 16px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

    }

    // 面包屑导航box
    .mianbao {
        box-sizing: border-box;
        margin: -16px -16px 0;
        background-color: #eef1f6;
        height: 47px;
        align-items: center;
        padding-left: 16px;
        margin-bottom: 16px;
    }

    .childrenFileSelect {
        margin-top: 20px;
    }

    .table {
    }

    .button1 {
        width: 400px;
        margin: 30px auto 0px;
        display: flex;
        justify-content: space-between;
    }

    .childrenFileSelect {
        border: 1px solid rgb(230, 230, 230);
        padding: 20px;
    }

    .el-form-item {
        margin-bottom: 20px !important;
    }

    .add {
        padding: 20px 0px;
    }

    .icon-icon7 {
        color: #dd3020;
    }

    .icon-tongguos {
        color: #0d5795;
    }

    .button {
        width: 400px;
        margin: 30px auto 0px;
        display: flex;
        justify-content: space-between;
    }
</style>
